//- 金錢的 Format
export default function(amount, sign = ',') {
  if (amount) {
    return amount
      .toString()
      .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function(
        all,
        pre,
        groupOf3Digital
      ) {
        return pre + groupOf3Digital.replace(/\d{3}/g, sign + '$&');
      });
  }

  return 0;
}